import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {getActiveFilterUrl} from "@/helpers/filter/filter-helper";
import {getFilterDomainList} from "@/http/services/http-services-filter";
import $ from "jquery";
import {updateFilterBadge} from "@/helpers/filter/filter-settings-helper";

export function setUpNumericObserver(element, formAttribute) {

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0) {
                blockUi(element, 0.5)
                const url = getActiveFilterUrl('minmax')
                const data = window.filterData
                data.column = formAttribute.ID
                getFilterDomainList(url,  data).then((response) => {
                    return response.json()
                }).then((result) => {

                    result = result.AggregationResults[0]

                    element.querySelectorAll('input').forEach((element, key) => {
                        element.value = result[key]
                    })

                    updateFilterBadge(element, result.join(' - '))

                    unblockUi(element)
                    observer.disconnect();
                })
            }
        });
    });
    observer.observe(element);
}

export function clearSelectize(element) {
    if($(element)[0].selectize !== undefined) {
        $(element)[0].selectize.clear();
    }
}
